import { Logger } from 'common/logger';
import { noteQuery, restrictionQuery, turbineStateQuery, catchErrorsV2 } from '../ReportsAPI';
import { createChartItem, CHART_GOUPS } from './helpers/turbineStatusChart.helper';
import { getSelectedItems } from 'common/state.helper';
import { REPORT_STATUSES } from 'lib/components/Timeline/Timeline.helpers';

/* eslint-disable camelcase */

const initialState = {
    notes: null,
    exceptions: null,
    restrictions: null,
    statuses: null,
};

export const turbineStatusChart = {
    name: 'turbineStatusChart',
    state: initialState,

    reducers: {
        setNotesData(state, { notes }) {
            return { ...state, notes };
        },
        setExceptionsData(state, { exceptions }) {
            return { ...state, exceptions };
        },
        setRestrictionsData(state, { restrictions }) {
            return { ...state, restrictions };
        },
        setStatusesData(state, { statuses }) {
            return { ...state, statuses };
        },
        resetState() {
            return initialState; // Optional: Add a reset state action if needed
        },
    },

    effects: (dispatch) => ({
        async loadAll() {
            await catchErrorsV2(
                () => dispatch.turbineStatusChart.queryNotesAndExceptions(),
                () => {
                    dispatch.turbineStatusChart.setNotesData({ notes: null });
                    dispatch.turbineStatusChart.setExceptionsData({ exceptions: null });
                }
            );
            await catchErrorsV2(
                () => dispatch.turbineStatusChart.queryRestrictions(),
                () => dispatch.turbineStatusChart.setRestrictionsData({ restrictions: null })
            );
            await catchErrorsV2(
                () => dispatch.turbineStatusChart.queryStatuses(),
                () => dispatch.turbineStatusChart.setStatusesData({ statuses: null })
            );
        },

        async queryNotesAndExceptions(_, state) {
            const { selectedDate, selectedParkId, selectedTurbineKey } = await getSelectedItems(state);
            const { data } = await noteQuery(selectedDate, selectedParkId, selectedTurbineKey);
            // Process data in a single loop
            const { notes, exceptions } = data.reduce(
                (acc, item) => {
                    if (item.note_type === 1 || item.note_type === 2) {
                        const chartItem = createChartItem(
                            item,
                            item.note_type === 1 ? CHART_GOUPS.NOTES : CHART_GOUPS.EXCEPTIONS,
                            selectedDate
                        );
                        item.note_type === 1 ? acc.notes.push(chartItem) : acc.exceptions.push(chartItem);
                    }

                    return acc;
                },
                { notes: [], exceptions: [] }
            );

            // Dispatch both updates in parallel
            Promise.all([
                dispatch.turbineStatusChart.setNotesData({ notes }),
                dispatch.turbineStatusChart.setExceptionsData({ exceptions }),
            ]);
        },

        async queryRestrictions(_, state) {
            const { selectedDate, selectedParkId, selectedTurbineKey } = await getSelectedItems(state);
            const { data } = await restrictionQuery(selectedDate, selectedParkId, selectedTurbineKey);
            const list = data.map((item) => createChartItem(item, CHART_GOUPS.RESTRICTIONS, selectedDate));
            dispatch.turbineStatusChart.setRestrictionsData({ restrictions: list });
        },

        async queryStatuses(_, state) {
            const { selectedDate, selectedParkId, selectedTurbineKey } = await getSelectedItems(state);
            const { data } = await turbineStateQuery(selectedDate, selectedParkId, selectedTurbineKey);
            const list = data
                .filter((item) => item.state !== REPORT_STATUSES.FAULT && item.state !== REPORT_STATUSES.WORKING)
                .map((item) => createChartItem(item, CHART_GOUPS.TURBINE_STATUSES, selectedDate));
            dispatch.turbineStatusChart.setStatusesData({ statuses: list });
        },
    }),

    subscriptions: {
        setup() {
            Logger.info('turbineStatusChart setup');
        },
    },
};

export default turbineStatusChart;
